import { getMeasureTextWidthCanvas, tableCellFormatterResult, removeMeasurementSpanCanvas, getValue } from '../utils'
import { MIN_COLUMN_WIDTH } from '../config'

let tableDataAutoKeyMap = {}

let cellContentColumns = []

const CELL_PADDING = 16

function headerCellOptionsSum (column) {
  let sum = 0
  const {
    sortable,
    tipsContent,
    tipsContentRender,
    filters,
    collapseKeys,
    textFlexWidget,
    cellContentPathWidth = 0
  } = column || {}
  let index = 0
  if ((sortable)) { // 排序
    sum += 13
    index += 1
  }
  if (tipsContent || tipsContentRender) { // 气泡提示
    sum += 13
    index += 1
  }
  if (filters) { // 过滤
    sum += 14
    index += 1
  }
  if (collapseKeys) { // 伸缩展开
    sum += 14
    index += 1
  }
  if (textFlexWidget) { // 组织缩进
    const num = 12 * 2 + 18
    sum += num
  }
  return sum + (index * 4) + parseInt(cellContentPathWidth)
}

export const CELL_CONTENT_FLAG = 'cellContent'

export function isCellContentColumnWidth (col, isStrict = true) {
  return col && (col.width === CELL_CONTENT_FLAG || (isStrict && col._autoWidthByCellContent))
}

function getAutoColumns (mainColumns) {
  return mainColumns.filter(col => isCellContentColumnWidth(col))
}

export function calculateMeasureTextWidthByColumn (column, content, isAddHeaderCellOptionSum) {
  const cellContentWidth = getMeasureTextWidthCanvas(content) + CELL_PADDING
  const headerCellOptionWidthSum = isAddHeaderCellOptionSum ? parseInt(headerCellOptionsSum(column)) : 0
  return cellContentWidth + headerCellOptionWidthSum
}

export function calculateCellContentColumnMinWidth (column) {
  const { label, minWidth } = column || {}
  const labelWidth = calculateMeasureTextWidthByColumn(column, label, true)
  return (minWidth && labelWidth < minWidth ? minWidth : labelWidth) || MIN_COLUMN_WIDTH
}


// 1 2
function createTableDataCellContentKeyMap ({rowData, rowIndex}, vm) {
  for (let i = 0; i < cellContentColumns.length; i++) {
    const col = cellContentColumns[i] || {}
    const { key } = col
    const text = tableCellFormatterResult(vm, { column: col, rowData, columnIndex: col.originIndex, rowIndex, displayText: getValue(key, rowData) })
    const leng = getMeasureTextWidthCanvas(text)
    if (!tableDataAutoKeyMap.hasOwnProperty(key)) {
      tableDataAutoKeyMap[key] = {
        text,
        leng,
        col,
        rowIndex
      }
    } else {
      const preLength = tableDataAutoKeyMap[key].leng
      if (preLength < leng) {
        tableDataAutoKeyMap[key] = {
          col,
          text,
          leng,
          rowIndex
        }
      }
    }
  }
}


export function createTable2ColumnWidthByCellContent (vm) {
  // 1列出所有配置为auto的列。
  // 2获取auto列的数据，根据字节判断找出最长的数据
  // 3测量列数据中最大的长度。 如果是rowCellRender、或配置了 formatter怎么处理？获取数据可通过回调？或者指定数据？ 最大最小原则。 最大？不需要。最小：不能小于 label的宽度。（保持文字与label的适配）
  // 4设置auto列的宽度。
  // 5重新渲染

  // 3
  const getCellContentTableDataWidthMap = () => {
    const map = Object.keys(tableDataAutoKeyMap)
    if (!Object.keys(map).length) {
      return cellContentColumns.reduce((res, col) => {
        res[col.key] = calculateCellContentColumnMinWidth(col)
        return res
      }, {})
    }
    return map.reduce((result, key) => {
      const { col, text } = tableDataAutoKeyMap[key]
      const width = calculateMeasureTextWidthByColumn(col, text)
      const minWidth = calculateCellContentColumnMinWidth(col)
      result[key] = width < minWidth ? minWidth : width
      return result
    }, {})
  }

  // 4 5
  const updateCellContentWidth = () => {
    const autoColumnMap = getCellContentTableDataWidthMap()
    for (const [key, width] of Object.entries(autoColumnMap)) {
      const column = vm.store.states.visibleFlatColumns.find(col => col.key === key)
      if (column && isCellContentColumnWidth(column)) {
        column.width = width
      }
    }
    vm.store.updateColumns()
  }

  const updateTableCellContentColumns = (data) => {
    tableDataAutoKeyMap = {}
    cellContentColumns = getAutoColumns(vm.store.states.mainColumns)
    if (!cellContentColumns.length) {
      return
    }
    if (data.length) {
      data.forEach((rowData, rowIndex) => {
        createTableDataCellContentKeyMap({rowData, rowIndex}, vm)
      })
    }
    updateCellContentWidth()
  }
  // 数据watch的时候处理
  vm.$watch('data', (data) => {
    updateTableCellContentColumns(data)
  }, {
    immediate: true
  })
  // 销毁
  vm.$on('hook:beforeDestroy', () => {
    removeMeasurementSpanCanvas()
  })
  // 销毁
  vm.$on('hook:destroyed', () => {
    removeMeasurementSpanCanvas()
  })
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/plugins/cell-content-width.js